import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Mostra un messaggio di successo e poi reindirizza alla dashboard
        const timer = setTimeout(() => {
            navigate('/dashboard');
        }, 5000); // Reindirizza dopo 5 secondi

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#2c2c2c',
            color: '#e0e0e0',
            textAlign: 'center'
        }}>
            <h1 style={{ color: '#4CAF50', fontSize: '3em' }}>Payment Successful!</h1>
            <p style={{ fontSize: '1.2em' }}>Thank you for your purchase. Credits have been added to your account.</p>
            <p style={{ marginTop: '20px' }}>You will be redirected to the dashboard in a few seconds...</p>
        </div>
    );
};

export default PaymentSuccess;
